import "../../style/scss/App.scss";
import { FaThumbsDown as ThumbsDown, FaThumbsUp as ThumbsUp, FaRegMeh as Meh } from "react-icons/fa";

/** Prefer the parent/base name when the catalog row is a version-named child. */
export function personSkillDisplayName(skill, personSkill) {
  if (skill?.ParentSkillName) return skill.ParentSkillName;
  return skill?.Name || personSkill?.SkillName || personSkill?.skillName || "Skill";
}

/** Group version children under their parent so the list shows one base skill. */
export function canonicalSkillId(skill, personSkill) {
  const parentId = Number(skill?.ParentID || skill?.parentID) || 0;
  if (parentId > 0) return parentId;
  return Number(personSkill?.SkillID || personSkill?.skillID || skill?.ID) || 0;
}

export default function PersonSkillListItem({ skill, personSkill, onEdit, onOpenForum }) {
  const experienceDisplay =
    personSkill.ExperienceMonths < 16
      ? personSkill.ExperienceMonths + " mo"
      : Math.floor(personSkill.ExperienceMonths / 12) + " yr";
  const title = personSkillDisplayName(skill, personSkill);
  const levelNames = { 1: "Beginner", 2: "Junior", 3: "Intermediate", 4: "Senior", 5: "Guru" };
  const verifiedLabel =
    personSkill.Certified || personSkill.VerifiedSkillLevel
      ? `Verified: ${levelNames[personSkill.VerifiedSkillLevel] || personSkill.VerifiedSkillLevel}`
      : null;
  const verificationStatus =
    personSkill.VerificationStatus || personSkill.verificationStatus || "";
  const verificationLabel = verifiedLabel
    ? verificationStatus === "expired"
      ? `${verifiedLabel} (expired)`
      : verificationStatus === "early"
        ? `${verifiedLabel} (expires soon)`
        : verifiedLabel
    : null;
  const accuracyRaw =
    personSkill.ClaimAccuracyEffective ?? personSkill.claimAccuracyEffective;
  const accuracyNum = accuracyRaw == null ? NaN : Number(accuracyRaw);
  const accuracyLabel = Number.isFinite(accuracyNum)
    ? `Claim trust: ${Math.round(accuracyNum * 100)}%`
    : null;
  const canRenew =
    personSkill.CanType2WriteVerification ?? personSkill.canType2WriteVerification;
  const id = personSkill.ID || personSkill.id;
  const forumSkillId = canonicalSkillId(skill, personSkill);

  return (
    <div className="personSkillRow">
      <button
        type="button"
        className="centered skillLink"
        data-testid={`person-skill-edit-${id}`}
        onClick={() => onEdit?.(id)}
      >
        <div className="Skill mobilePanel">
          <span className="title">
            {title}
            {verificationLabel ? (
              <span className="verifiedBadge" title="Type 1 / Type 2 certification">
                {" "}
                [{verificationLabel}]
              </span>
            ) : null}
            {accuracyLabel ? (
              <span className="claimAccuracyBadge" title="System claim accuracy (effective)">
                {" "}
                · {accuracyLabel}
              </span>
            ) : null}
            {canRenew ? (
              <span className="claimAccuracyBadge" title="Renew with Type 2 level detection">
                {" "}
                · renew available
              </span>
            ) : null}
          </span>
          <span className="byline">{skill?.CategoryName}</span>
          <span className="rightText">
            {experienceDisplay} at {(personSkill.Employments || []).length} jobs
            <span className="icon">
              <span className={personSkill.InterestLevelID === 1 ? "" : "hidden"}>
                <ThumbsUp className="interestLevelIcon up" />
              </span>
              <span className={personSkill.InterestLevelID === 0 ? "" : "hidden"}>
                <Meh className="interestLevelIcon meh" />
              </span>
              <span className={personSkill.InterestLevelID === 2 ? "" : "hidden"}>
                <ThumbsDown className="interestLevelIcon down" />
              </span>
            </span>
          </span>
        </div>
      </button>
      {forumSkillId > 0 ? (
        <button
          type="button"
          className="personSkillForumButton"
          data-testid={`skill-forum-open-${forumSkillId}`}
          onClick={(event) => {
            event.stopPropagation();
            onOpenForum?.(personSkill);
          }}
        >
          Forum
        </button>
      ) : null}
    </div>
  );
}
